export default __webpack_public_path__ + "static/media/headshot.12c78589.jpg";